import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle,
} from '@ps/ds/components/blocks/Item/Item'
import { formatString } from '@ps/tools/helpers/string'
import { ChevronRight, Phone, Truck } from 'lucide-react'
import { TrackingWorkOrderProvider } from 'src/api/domains/service-tracking/serviceTracking.types'
import { NS } from 'src/constants/i18n'

type CallServiceProviderItemProps = {
  provider: TrackingWorkOrderProvider
}

export const CallServiceProviderItem: FC<CallServiceProviderItemProps> = ({ provider }) => {
  const { t } = useTranslation(NS.TRACKING)

  const formattedPhoneNumber = formatString.toFormattedPhoneNumber(provider.phone)
  const providerName = formatString.toTitleCase(provider.name)

  return (
    <Item asChild className="w-full md:flex-nowrap">
      <a href={`tel:${provider.phone}`}>
        <ItemMedia variant="icon">
          <div className="w-10 h-10 p-[10px] bg-navy-400 rounded-full flex items-center justify-center">
            <Phone className="text-white md:hidden" />
            <Truck className="text-white hidden md:block" />
          </div>
        </ItemMedia>

        <ItemContent className="min-w-0">
          <ItemTitle>{t(`contact.options.phone.labelWithProvider`, { providerName })}</ItemTitle>

          <ItemDescription className="hidden truncate md:block">
            {formattedPhoneNumber}
          </ItemDescription>

          <ItemDescription className="block md:hidden">
            {t('contact.assignedProvider')}
          </ItemDescription>
        </ItemContent>

        <ItemActions className="hidden md:block">
          <ChevronRight />
        </ItemActions>
      </a>
    </Item>
  )
}
